import { Component } from '@theme/component';

class ImageSliderComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    const container = this.querySelector('[ref="slider"]');
    if (!container) return;

    this.#loadSlick().then(() => {
      const autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 4000;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.jQuery(container).slick({
        fade: true,
        autoplay: !prefersReducedMotion,
        autoplaySpeed,
        pauseOnHover: true,
        arrows: false,
        dots: true,
        infinite: true,
        speed: 800,
        adaptiveHeight: true,
      });
    });
  }

  async #loadSlick() {
    // Load slick CSS
    this.#loadCSS('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css');
    this.#loadCSS('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css');

    // Load jQuery if not present
    if (!window.jQuery) {
      await this.#loadScript('https://cdn.jsdelivr.net/npm/jquery@3.7.1/dist/jquery.min.js');
    }

    // Load slick JS
    if (!window.jQuery.fn.slick) {
      await this.#loadScript('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js');
    }
  }

  /** @param {string} href */
  #loadCSS(href) {
    if (document.querySelector(`link[href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  /** @param {string} src */
  #loadScript(src) {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
}

if (!customElements.get('image-slider-component')) {
  customElements.define('image-slider-component', ImageSliderComponent);
}
